import React from 'react';
import { Loading, LiveStatusRegion } from 'ui';

import useSignUpStatus from './useSignUpStatus';

import type { SignUpStatusProps } from './useSignUpStatus';

function SignUpStatus({ isLoading }: SignUpStatusProps): JSX.Element {
  const { message } = useSignUpStatus({ isLoading });

  return (
    <>
      <LiveStatusRegion message={message} />
      {/* `Loading` nace con su texto y no se anunciaría: la región de arriba es la única señal. */}
      {isLoading && (
        <div aria-hidden="true">
          <Loading />
        </div>
      )}
    </>
  );
}

export default SignUpStatus;
